'use client';

import { useId } from 'react';

/**
 * Gradient external-link badge ported 1:1 from PopshopRN's `react-native-svg`
 * `ExternalProductLinkIcon` — `lucide-react` can't express the gradient fill,
 * so it stays a hand-authored inline SVG. `useId()` gives each instance a
 * unique gradient id (RN used `useUniqueSvgElementId`).
 *
 * Lives in `@ps/ui` (not a feature slice) so both the shared `ProductCard`
 * molecule and the `@ps/features` product surfaces render the SAME badge.
 */
export function ExternalProductLinkIcon({ size = 22 }: { size?: number }) {
  const gradientId = useId();
  return (
    <svg width={size} height={size} viewBox="0 0 22 23" fill="none" aria-hidden>
      <defs>
        <linearGradient
          id={gradientId}
          x1="0"
          y1="11.6196"
          x2="22"
          y2="11.6196"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2EAC03" />
          <stop offset="1" stopColor="#00ACDB" />
        </linearGradient>
      </defs>
      <rect
        y="0.619629"
        width="22"
        height="22"
        rx="11"
        fill={`url(#${gradientId})`}
      />
      <path
        d="M16.25 10.3071C16.25 10.4232 16.2039 10.5344 16.1219 10.6165C16.0398 10.6985 15.9285 10.7446 15.8125 10.7446C15.6965 10.7446 15.5852 10.6985 15.5031 10.6165C15.4211 10.5344 15.375 10.4232 15.375 10.3071V7.86369L11.7476 11.4917C11.6655 11.5738 11.5541 11.6199 11.438 11.6199C11.3219 11.6199 11.2106 11.5738 11.1285 11.4917C11.0464 11.4096 11.0003 11.2982 11.0003 11.1821C11.0003 11.066 11.0464 10.9547 11.1285 10.8726L14.7559 7.24463H12.3125C12.1965 7.24463 12.0852 7.19854 12.0031 7.11649C11.9211 7.03444 11.875 6.92316 11.875 6.80713C11.875 6.6911 11.9211 6.57982 12.0031 6.49777C12.0852 6.41572 12.1965 6.36963 12.3125 6.36963H15.8125C15.9285 6.36963 16.0398 6.41572 16.1219 6.49777C16.2039 6.57982 16.25 6.6911 16.25 6.80713V10.3071ZM14.0625 11.6196C13.9465 11.6196 13.8352 11.6657 13.7531 11.7478C13.6711 11.8298 13.625 11.9411 13.625 12.0571V15.9946H6.625V8.99463H10.5625C10.6785 8.99463 10.7898 8.94854 10.8719 8.86649C10.9539 8.78444 11 8.67316 11 8.55713C11 8.4411 10.9539 8.32982 10.8719 8.24777C10.7898 8.16572 10.6785 8.11963 10.5625 8.11963H6.625C6.39294 8.11963 6.17038 8.21182 6.00628 8.37591C5.84219 8.54 5.75 8.76256 5.75 8.99463V15.9946C5.75 16.2267 5.84219 16.4493 6.00628 16.6133C6.17038 16.7774 6.39294 16.8696 6.625 16.8696H13.625C13.8571 16.8696 14.0796 16.7774 14.2437 16.6133C14.4078 16.4493 14.5 16.2267 14.5 15.9946V12.0571C14.5 11.9411 14.4539 11.8298 14.3719 11.7478C14.2898 11.6657 14.1785 11.6196 14.0625 11.6196Z"
        fill="white"
      />
    </svg>
  );
}
